// extracted by mini-css-extract-plugin
module.exports = {"base":"SectionHeading_base__KsuBA","small":"SectionHeading_small__3g7yX","big":"SectionHeading_big__1U7jy"};